module.exports = __webpack_public_path__ + "static/media/IMG_5.c1facad3.jpg";